// extracted by mini-css-extract-plugin
module.exports = {"impermaxInput":"impermax-input_impermaxInput__3SccD"};